import { InjectionToken } from '@angular/core';
import { environment } from 'src/environments/environment';

export type Environment = typeof environment;
export const ENVIRONMENT = new InjectionToken<Environment>("Environment");

export function provideEnvironment(env: Environment = environment) {
  return { provide: ENVIRONMENT, useValue: env, multi: false };
}
